import React, { ChangeEvent, FormEvent, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { ScreenContainer } from "../../components/containers";
//
interface FormData {
  name: string;
  phoneNumber: string;
  emailAddress: string;
  companyName: string;
}
const lineBreak = `<br>`;
const lineBWithSpace = `<br>&nbsp;&nbsp;`;

interface FormState {
  initial: { log: string; styleClass: string };
  processing: { log: string; styleClass: string };
  sent: { log: string; styleClass: string };
  error: { log: string; styleClass: string };
}
const FormStates: FormState = {
  initial: { log: "", styleClass: "initial" },
  processing: {
    log: "We are sending your information...",
    styleClass: "processing",
  },
  sent: {
    log: "We have sent the quote, someone will contact you shortly...",
    styleClass: "sent",
  },
  error: {
    log: "There is a problem, please try again or contact us at 01 4475299...",
    styleClass: "error",
  },
};
const baseUrl = "/" + window.location.pathname.split("/")[1] || "/";

const ContactScreen9: React.FC = () => {
  //const { sites } = useAppContext();
  const navigate = useNavigate();
  const { state } = useLocation();
  const [formData, setFormData] = useState<FormData>({
    name: "",
    phoneNumber: "",
    emailAddress: "",
    companyName: "",
  });
  const [formStatus, setFormStatus] = useState<(typeof FormStates)["initial"]>(
    FormStates.initial
  );

  useEffect(() => {
    const interval = setInterval(() => {
      if (formStatus === FormStates.sent) {
        window.location.replace(baseUrl);
      }
    }, 2000);
    return () => clearInterval(interval);
  }, [formStatus]);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const treatInformation = () => {
    let messageBody: string = `<br>`;
    //formatting sites'info
    messageBody += `POS SOLUTION: ${state?.POSSolutionName} <br>`;
    messageBody += "Contract Duration: " + state?.selectedContractDuration;
    messageBody += lineBreak;
    state?.sitesCost.forEach((sites: any) => {
      messageBody += lineBreak + sites.sectionName + lineBWithSpace;
      sites.modules.forEach((mod: any) => {
        messageBody += lineBreak + mod.moduleName + lineBWithSpace;
        mod.units.forEach((unit: any) => {
          messageBody +=
            unit.unitName + ": " + unit.formattedPrice + lineBWithSpace;
        });
      });
    });
    messageBody += lineBreak + lineBreak;
    //formatting delivery
    state?.deliveryInstallationCost[0].modules.forEach((mod: any) => {
      messageBody += mod.moduleName + lineBWithSpace;
      mod.units.forEach((unit: any) => {
        messageBody +=
          unit.unitName + ": " + unit.formattedPrice + lineBWithSpace;
      });
    });
    messageBody += lineBreak + lineBreak;
    //formatting product conf cost
    state?.productConfCost[0].modules.forEach((mod: any) => {
      messageBody += mod.moduleName + lineBWithSpace;
      mod.units.forEach((unit: any) => {
        messageBody +=
          unit.unitName + ": " + unit.formattedPrice + lineBWithSpace;
      });
    });
    messageBody += lineBreak + lineBreak;
    messageBody +=
      "Average Transaction Amount? " +
      state?.averageTransactionAmount +
      lineBreak;
    messageBody +=
      "How much do you expect to process through your card machine per month?: " +
      state?.processPerMonth +
      lineBreak +
      lineBreak;
    messageBody += "Total One-Off Fee: " + state?.oneOffCost + lineBreak;
    messageBody += "Total Monthly Fee: " + state?.monthlyTotal + lineBreak;

    return messageBody;
  };

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();

    try {
      setFormStatus(FormStates.processing);
      let messageBody = treatInformation();
      //console.log(messageBody);
      const response = await axios.post(
        "https://npi.ie/wp-json/npimail/v1/fee-calculator",
        {
          name: formData.name,
          email_address: formData.emailAddress,
          phone_number: formData.phoneNumber,
          company_name: formData.companyName,
          options: [
            {
              key: "*********************** QUOTATION ***********************",
              value: messageBody,
            },
          ],
        }
      );
      setFormData({
        name: "",
        phoneNumber: "",
        emailAddress: "",
        companyName: "",
      });
      setFormStatus(FormStates.sent);
      //console.log(response);
    } catch (error) {
      console.error("Error submitting form:", error);
      setFormStatus(FormStates.error);
    }
  };

  return (
    <ScreenContainer
      title="Get In Contact with Us"
      subtitle="A member of our team will contact you to continue with your purchase"
    >
      <form onSubmit={handleSubmit} id="epos-contact-form">
        <input
          placeholder="Name"
          type="text"
          name="name"
          value={formData.name}
          onChange={handleChange}
          required
        />

        <input
          placeholder="Phone Number"
          type="tel"
          name="phoneNumber"
          //pattern="[0-9]"
          value={formData.phoneNumber}
          onChange={handleChange}
          required
        />

        <input
          placeholder="Email Address"
          type="email"
          name="emailAddress"
          value={formData.emailAddress}
          onChange={handleChange}
          required
        />

        <input
          placeholder="Company Name"
          type="text"
          name="companyName"
          value={formData.companyName}
          onChange={handleChange}
        />

        {[FormStates.initial, FormStates.error, FormStates.sent].includes(
          formStatus
        ) && <button type="submit">Send Quotation</button>}

        <div className="form-log">
          {[FormStates.error, FormStates.sent, FormStates.processing].includes(
            formStatus
          ) && (
            <span className={`${formStatus.styleClass} log`}>
              {formStatus.log}
            </span>
          )}
        </div>
      </form>

      <div className="buttons-container">
        <button
          className="app-button previous-button"
          onClick={() => navigate(-1)}
        >
          Previous
        </button>
      </div>
    </ScreenContainer>
  );
};

export default ContactScreen9;
